import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import Button from 'antd/lib/button';
import { ResponsiveTable } from '../../../common/components/data-display';
import {
  accountDocumentTypesOptional,
  accountDocumentTypesT,
  accountDocumentObligations,
} from '../../../common/enums';
import { OpenFileLink } from '../../../common/components/data-display';
import DocumentUpload from './DocumentUpload';
import DocumentSelect from './DocumentSelect';

const Column = Table.Column;

@translate()
export default class DocumentList extends Component {
  static propTypes = {
    documents: PropTypes.array.isRequired,
    token: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    onUpload: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onOptionalDocumentChange: PropTypes.func.isRequired,
    optionalDocumentType: PropTypes.oneOf(accountDocumentTypesOptional),
    uploadingAvailable: PropTypes.bool.isRequired,
    allowedMimeTypes: PropTypes.array.isRequired,
    // NEW
    bankStatementsLocked: PropTypes.bool,
    bankStatementTypes: PropTypes.array,
  };

  static defaultProps = {
    bankStatementsLocked: false,
    bankStatementTypes: [],
  };

  isBankStatement = (documentType) => {
    const { bankStatementTypes } = this.props;
    return bankStatementTypes && bankStatementTypes.indexOf(documentType) !== -1;
  };

  render() {
    const {
      documents,
      token,
      loading,
      onUpload,
      onRemove,
      onOptionalDocumentChange,
      optionalDocumentType,
      uploadingAvailable,
      allowedMimeTypes,
      bankStatementsLocked,
      t,
    } = this.props;

    return (
      <section className="document-list">
        <ResponsiveTable
          dataSource={documents}
          rowKey={(doc, idx) => `${doc.documentType}${idx}`}
          pagination={false}
          loading={loading}
        >
          <Column
            className="document-type"
            title={t('Typ dokumentu')}
            dataIndex="documentObligation"
            key="type"
            render={(documentObligation, doc) => {
              switch (documentObligation) {
                case accountDocumentObligations.REQUIRED:
                  return <span>{accountDocumentTypesT[doc.documentType]}</span>;
                case accountDocumentObligations.OPTIONAL:
                  return !uploadingAvailable && accountDocumentTypesT[doc.documentType] ? (
                    <span>{accountDocumentTypesT[doc.documentType]}</span>
                  ) : (
                    <DocumentSelect
                      selectedValue={optionalDocumentType}
                      handeSelect={onOptionalDocumentChange}
                      options={accountDocumentTypesOptional}
                      translations={accountDocumentTypesT}
                      disabled={!uploadingAvailable}
                    />
                  );
                default:
                  return null;
              }
            }}
          />
          <Column
            title={t('Názov súboru')}
            className="fileNameColumn"
            dataIndex="file"
            key="name"
            render={file => file && file.name}
          />
          <Column
            title={t('Akcie')}
            dataIndex="file"
            key="actions"
            render={(file, doc) => {
              const isStatement = this.isBankStatement(doc.documentType);

              if (isStatement && bankStatementsLocked) {
                return <span>{t('Nahraté online')}</span>;
              }

              return file && file.id ? (
                <div className="document-action">
                  {uploadingAvailable && (
                    <React.Fragment>
                      <MediaQuery maxDeviceWidth={768}>
                        <DocumentUpload
                          onUpload={onUpload(doc)}
                          onRemove={onRemove(doc)}
                          uploadTitle={t('Nahrať')}
                          allowedMimeTypes={allowedMimeTypes}
                          disabled={!uploadingAvailable}
                          className="document-upload-button"
                        />
                      </MediaQuery>
                      <MediaQuery minDeviceWidth={769}>
                        <DocumentUpload
                          onUpload={onUpload(doc)}
                          onRemove={onRemove(doc)}
                          uploadTitle={t('Nahrajte nový')}
                          allowedMimeTypes={allowedMimeTypes}
                          disabled={!uploadingAvailable}
                          className="document-upload-button"
                        />
                      </MediaQuery>
                    </React.Fragment>
                  )}
                  {file && file.link && (
                    <OpenFileLink href={`${file.link}?token=${token}`}>
                      <Button size="small" className="btn-inline">
                        {t('Otvoriť')}
                      </Button>
                    </OpenFileLink>
                  )}
                </div>
              ) : (
                <DocumentUpload
                  onUpload={onUpload(doc)}
                  onRemove={onRemove(doc)}
                  uploadTitle={t('Vyberte súbor')}
                  allowedMimeTypes={allowedMimeTypes}
                  disabled={!uploadingAvailable}
                  className="document-upload-button"
                />
              );
            }}
          />
        </ResponsiveTable>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/features/documents/components/DocumentList.js